// Helpers para trabajar con la configuración de pricing

import pricingConfigData from "../data/pricingConfig.json";

// Cargar configuración
export const pricingConfig = pricingConfigData;

/**
 * Obtiene el texto según la variante de copy seleccionada
 * @param {Object} textObj - Objeto con las variantes de texto {neutral, fun, direct}
 * @param {string} variant - Variante a usar (por defecto usa la variante actual del config)
 * @returns {string} El texto de la variante seleccionada
 */
export function getText(textObj, variant) {
  if (!textObj) return "";
  const selectedVariant = variant || pricingConfig.copyVariants.current;
  return textObj[selectedVariant] || textObj.neutral || "";
}

/**
 * Obtiene la variante de copy actual
 * @returns {string}
 */
export function getCurrentVariant() {
  return pricingConfig.copyVariants.current;
}

/**
 * Obtiene el trigger del paywall por acción
 * @param {string} action - Acción que dispara el paywall
 * @returns {Object|null}
 */
export function getPaywallTrigger(action) {
  return (
    pricingConfig.paywallModal.triggers.find((trigger) => trigger.action === action) || null
  );
}

/**
 * Obtiene el estado del editor según el tipo de usuario
 * @param {string} userState - "free" | "oneTime" | "annual"
 * @returns {Object}
 */
export function getEditorState(userState) {
  return pricingConfig.editorStates[userState] || pricingConfig.editorStates.free;
}

/**
 * Verifica si una acción está permitida para el usuario
 * @param {string} userState - "free" | "oneTime" | "annual"
 * @param {string} action - Acción a verificar
 * @returns {boolean}
 */
export function canPerformAction(userState, action) {
  const editorState = getEditorState(userState);
  return editorState.enabledActions.includes(action);
}

/**
 * Determina el estado del usuario basándose en su información de suscripción
 * @param {Object} user - Objeto usuario con información de suscripción
 * @returns {string} "free" | "oneTime" | "annual"
 */
export function getUserState(user) {
  if (!user) return "free";
  
  // Verificar si tiene suscripción anual
  if (user.subscriptionType === "annual" || user.plan === "annual") {
    return "annual";
  }
  
  // Verificar si tiene pago único
  if (user.subscriptionType === "oneTime" || user.plan === "oneTime" || user.hasPaid) {
    return "oneTime";
  }
  
  // Por defecto, usuario gratuito
  return "free";
}

